export enum StockFeatureType {
  oldFeatures = 'oldSelectedFeatures',
  features = 'selectedFeatures',
}
